import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

const authHeaders = () => {
  const raw = localStorage.getItem("userDetails");
  const token = raw ? JSON.parse(raw)?.token : null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const createWorkProgressApi = (data) =>
  axios.post(`${API_BASE_URL}/api/workprogress`, data, {
    headers: authHeaders(),
  });

export const updateWorkProgressApi = (id, data) =>
  axios.put(`${API_BASE_URL}/api/workprogress/${id}`, data, {
    headers: authHeaders(),
  });
